import genericFunctionsUtils from '@/services/common/genericFunctions.utils';
import pixRegexUtils from '@/services/regularExpressions/pixRegex.utils';
import pixMath from '@/services/common/pixMath.utils';
import regexEnum from '@/consts/regex.const.js';

const evaluateGenericExpression = function (expression = '', evaluableGenericField, evaluableGenericFields = [], shouldTransform = false) {
  const mutatedExpression = _getMutatedExpression(expression, evaluableGenericField, evaluableGenericFields);

  let evaluationResult;

  if (mutatedExpression.match(regexEnum.FUNCTION_EXPRESSION)) {
    evaluationResult = _getAssociatedFunctionValue(mutatedExpression, shouldTransform);
  } else {
    try {
      evaluationResult = pixMath.evaluate(mutatedExpression);
    } catch (err) {
      // console.error(`Unable to evaluate the expression ${expression}`);
      evaluationResult = null;
    }
  }

  return Number.isNaN(evaluationResult) ? null : evaluationResult;
};

const _getMutatedExpression = function (expression, evaluableGenericField, evaluableGenericFields) {
  let mutableExpression = expression;
  const terms = [...new Set(pixRegexUtils.getRegexMatches(regexEnum.EVAL_UNQUOTED_WHOLE_WORD, expression))];

  for (const term of terms) {
    const termModel = term === 'this' ? evaluableGenericField : evaluableGenericFields?.find(({ InternalField }) => InternalField === term) ?? { Value: null };

    if (termModel) {
      mutableExpression = mutableExpression.replaceAll(term, typeof termModel.Value == 'string' ? `'${termModel.Value}'` : termModel.Value ?? null);
    }
  }

  return mutableExpression;
};

const _getAssociatedFunctionValue = function (expression, shouldTransform) {
  const [functionName] = expression.match(regexEnum.FUNCTION_NAME);

  if (!functionName) return null;

  if (!Object.keys(_associatedFunctions).includes(functionName)) return null;

  const [functionArguments] = expression.match(regexEnum.FUNCTION_ARGUMENTS);

  if (!functionArguments) return _associatedFunctions[functionName]();

  const mutatedArguments = functionArguments.split(',').map((argument) => {
    const trimmedArgument = argument.trim().replaceAll("'", '');
    if (trimmedArgument === 'null') {
      return null;
    }
    return trimmedArgument;
  });

  return _associatedFunctions[functionName](...mutatedArguments, shouldTransform);
};

export const _associatedFunctions = {
  trunc: genericFunctionsUtils.pixTrunc,
  min: genericFunctionsUtils.pixMin,
  transformMonthsToYearsMonths: genericFunctionsUtils.transformMonthsToYearsMonths,
  transformYearsToYearsMonths: genericFunctionsUtils.transformYearsToYearsMonths,
  oneOutOfPrefix: genericFunctionsUtils.oneOutOfPrefix,
};

export default {
  evaluateGenericExpression,
};
